// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"62a978e5","429":"8aa23153","689":"38e82c01","871":"65c231d2"}[chunkId] + ".chunk.js";
};